import React, { useState, useEffect } from 'react';
import { Modal, Form, Row, Col, Button, Table, Card, Descriptions, Input } from 'antd';
import styles from './index.less';
import { print } from '@/utils/printUtils';
import moment from 'moment';

const { TextArea } = Input;

const PrintModal = ({ taskDetail = {}, info = {}, visible, ...other }) => {
  const [currentInfo, setCurrentInfo] = useState({});

  useEffect(
    () => {
      if (info) {
        setCurrentInfo({ ...info });
      }
    },
    [info]
  );

  const handlePrint = () => {
    const printContent = document.getElementById('printDetails1').parentNode;
    setTimeout(() => {
      print(printContent);
    }, 1500);
  };

  const modalProps = {
    visible: visible,
    // onCancel,
    width: 800,
    okText: '打印',
    ...other,
  };

  const handleChange = (key, value) => {
    let newInfo = { ...currentInfo };
    newInfo[key] = value;
    setCurrentInfo({ ...newInfo });
  };

  return (
    <Modal {...modalProps} closable={false} title="" onOk={() => handlePrint()}>
      <div id="printDetails1">
        <div className={styles.BSPPrint} id="printDetails">
          <h2 className={'print-title'} style={{ textAlign: 'center' }}>
            咨询服务简表
          </h2>
          <div
            className={'print-sub-title'}
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              lineHeight: '28px',
              fontSize: '14px',
              color: '#40a9ff',
            }}
          >
            <div>
              来访者姓名：
              <TextArea
                style={{ width: 60, marginBottom: 5 }}
                value={currentInfo.visitorName}
                autoSize={{ minRows: 1 }}
                onChange={e => handleChange('visitorName', e.target.value)}
              />
            </div>
            <div>
              心理师姓名：
              <TextArea
                style={{ width: 60, marginBottom: 5 }}
                value={currentInfo.consultantName}
                autoSize={{ minRows: 1 }}
                onChange={e => handleChange('consultantName', e.target.value)}
              />
            </div>
            <div>
              日期时间：
              <TextArea
                style={{ width: 80, marginBottom: 5 }}
                value={currentInfo.documentDate}
                autoSize={{ minRows: 1 }}
                onChange={e => handleChange('documentDate', e.target.value)}
              />
            </div>
            <div>
              第
              <TextArea
                style={{ width: 30, marginBottom: 5 }}
                value={currentInfo.count}
                autoSize={{ minRows: 1 }}
                onChange={e => handleChange('count', e.target.value)}
              />
              次
            </div>
          </div>
          <div className={styles.bspCommontContain}>
            <h3 className="title">
              <div>服务目标</div>
            </h3>
            <Descriptions bordered column={1}>
              <Descriptions.Item span={1} label="本阶段目标">
                <div style={{ padding: '8px 16px' }}>
                  {currentInfo.thisStageConsultationGoal}
                  {/* <TextArea
                    value={currentInfo.thisStageConsultationGoal}
                    autoSize={{ minRows: 1 }}
                    onChange={e => handleChange('thisStageConsultationGoal', e.target.value)}
                  /> */}
                </div>
              </Descriptions.Item>
              <Descriptions.Item span={1} label="本次目标">
                <div style={{ padding: '8px 16px' }}>
                  {currentInfo.thisTimeConsultationGoal}
                  {/* <TextArea
                    value={currentInfo.thisTimeConsultationGoal}
                    autoSize={{ minRows: 1 }}
                    onChange={e => handleChange('thisTimeConsultationGoal', e.target.value)}
                  /> */}
                </div>
              </Descriptions.Item>
            </Descriptions>
          </div>
          <div className={styles.bspCommontContain}>
            <h3 className="title">
              <div>本次服务记录</div>
            </h3>
            <div style={{ padding: '8px 16px', border: '1px solid #e8e8e8' }}>
              {currentInfo.thisTimeServiceLog}
              {/* <TextArea
                value={currentInfo.thisTimeServiceLog}
                autoSize={{ minRows: 10 }}
                onChange={e => handleChange('thisTimeServiceLog', e.target.value)}
              /> */}
            </div>
          </div>
          {
            currentInfo.imageArray && currentInfo.imageArray.map(it => {
              return <img style={{ width: 750 }} src={it} />
            })
          }
          {/* <div className={styles.bspCommontContain}>
              <h3 className='title'><div>本次服务总结</div></h3>
              <div style={{ padding: '8px 16px', border: '1px solid #e8e8e8' }}>
                <TextArea value={currentInfo.thisTimeServiceSummary} autoSize={{ minRows: 10 }} onChange={e => handleChange('thisTimeServiceSummary', e.target.value)} />
              </div>
            </div> */}
        </div>
      </div>
    </Modal>
  );
};

export default Form.create()(PrintModal);
